import React from 'react'

import Button from 'components_new/atoms/Button'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'

import { useTranslation } from 'language/translator'

interface NoSliceProps {
  embedded: boolean
  isAdmin: boolean
  onOpenSettings: () => void
  scaleFactor: number
}

const NoSlice = (props: NoSliceProps) => {
  const { embedded, isAdmin, onOpenSettings, scaleFactor } = props
  const { t } = useTranslation()

  const allowConfigureSlice = !embedded && isAdmin

  return (
    <EmptyPlaceholder
      actions={
        allowConfigureSlice ? (
          <Button onClick={onOpenSettings}>
            {t('widgets', 'configure_slice')}
          </Button>
        ) : undefined
      }
      background={true}
      title={t('widgets', 'widget_missing_slices_error')}
      icon="Slices"
      scaleFactor={scaleFactor}
    />
  )
}

export default NoSlice
